define('views/content/signin',['require','backbone','marionette','jquery-validation','text!templates/content/signin.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');

    var temp = require("text!templates/content/signin.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        initialize: function(options) {

        },

        ui: function() {
            return {
                email: 'input[name="email"]',
                password: 'input[name="password"]',

                submitButton: '.submit-button',

                signinForm: '#form-signin'
            };
        },

        events: {
            'click @ui.submitButton': 'submitButtonClicked',
            'keypress @ui.password': 'passwordKeypress'
        },

        onRender: function () {
            this.ui.signinForm.validate();
        },

        passwordKeypress: function (e) {
            if (e.which == 13) {
                this.submitButtonClicked();
            }
        },

        submitButtonClicked: function () {
            var _this = this;
            
            if (this.ui.signinForm.valid()) {

                this.ui.submitButton.addClass('loading');

                App.context.login(
                    {
                        email: this.ui.email.val(),
                        password: this.ui.password.val()
                    },
                    function () {

                        // Login successful
                        _this.ui.submitButton.removeClass('loading');


                        if (App.utils.getUrlParameter('next')) {
                            App.context.redirect(App.utils.getUrlParameter('next'));
                        } else {
                            App.context.redirect('/');
                        }
                    },
                    function (errors) {
                        _this.ui.submitButton.removeClass('loading');

                        // Display sign in related error messages
                        App.utils.showMessage('error', errors.responseJSON.errors[0].message);
                    }
                );

            }
        }

    });
});
